/*
  Real records on the UAT digibank tenant (read 2026-11-04). The demo treats them as the records the
  backend created for a proposal, so the edit-mode builders load real data. Demo saves are answered
  in the browser (see holdDemoModuleSaves); they never change these records.
*/
export const DEMO_UAT_RECORDS = {
  stampCampaign: { id: 34, name: '[PERXSUPPORT]-October13-stamp' },
  editCampaign: { id: 1, name: '[PERXSUPPORT]Stamp' },
  reward: { id: 67, name: 'rewards tag 1' },
  rule: { id: 1, name: '[PERXSUPPORT]-October13-stamp' },
  loyaltyProgram: { id: 1, name: 'Perx AI Workspace' }
} as const;
